import React from "react";
import { cloudinaryInstance } from "../../../../utilities/Cloudinary/cloudinaryInstance";
import { fill } from "@cloudinary/url-gen/actions/resize";
import { Link } from "react-router-dom";
import { AdvancedImage } from "@cloudinary/react";
import localeText from "../../../../locale";
import { PLATFORM_PRODUCT_FEE } from "../../../../utilities/constants";
import { formatPrice } from "../../../../utilities/formatPrice";
import { useLocation } from "react-router-dom";

const ProductRow = ({ item, index, orderItems, quantity, currencyFormat = {} }) => {
  const location = useLocation();

  const isFringeBenefitsPage = location?.pathname?.toLowerCase()?.includes("fringe");

  const productUrl = isFringeBenefitsPage ? "/fringe-benefit" : "/product";

  const formatPriceFee = (product) => {
    const price = product.priceUnitary;
    const priceWithFEE = price + price * PLATFORM_PRODUCT_FEE;

    return formatPrice(priceWithFEE);
  };

  const getCurrency = () => {
    if (isFringeBenefitsPage) {
      return currencyFormat[item.fringeBenefit.currency] || item.fringeBenefit.currency;
    }
    return currencyFormat[item.product.currency] || item.product.currency;
  };

  const getPrice = () => {
    if (isFringeBenefitsPage) {
      return item.fringeBenefit.price;
    }
    return item.priceUnitary;
  };

  return (
    <div
      className="flex gap-3"
      style={{
        borderBottom:
          orderItems.length > 1 && index < orderItems.length - 1 ? "1px solid #dee2e6" : undefined,
        paddingBottom:
          orderItems.length > 1 && index < orderItems.length - 1 ? "1.5rem" : undefined,
      }}
    >
      <Link
        to={`${productUrl}/${isFringeBenefitsPage ? item.fringeBenefit.id : item.product.id}`}
        style={{ height: "110px" }}
      >
        <AdvancedImage
          cldImg={
            item.productVariation && item.productVariation.imageid
              ? cloudinaryInstance
                  .image(item.productVariation.imageid)
                  .resize(fill().width(600).height(600))
                  .format("webp")
              : cloudinaryInstance
                  .image(isFringeBenefitsPage ? item.fringeBenefit.imageid1 : item.product.imageid1)
                  .resize(fill().width(600).height(600))
                  .format("webp")
          }
          height={110}
          className="h-100"
        />
      </Link>
      <div className="flex flex-column">
        <div className="font-semibold" style={{ color: "#344563" }}>
          {isFringeBenefitsPage ? item.fringeBenefit.title : item.product.title}
        </div>
        <div className="flex gap-2 text-xs mt-2" style={{ color: "#7A869A" }}>
          <div>{localeText("quantity")}:</div>
          <div>{item.quantity}</div>
        </div>
        <div
          className="flex gap-2 align-items-end h-full font-bold mb-2"
          style={{ color: "#344563" }}
        >
          {getCurrency()} {formatPrice(getPrice())}
        </div>
      </div>
    </div>
  );
};

export default ProductRow;
